// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5359":"69935b32fe84f24b","5642":"8d6d7466d8db3155","6249":"d583b84cefbdab71"}[chunkId] + ".css";
};